export const FONTS = {
  ArialMTBlack: 'ArialMTBlack',
  AvenirMedium: 'Avenir-Medium',
  AvenirLTStdBlack: 'AvenirLTStd-Black',
  IowanOldStyleBTRoman: 'IowanOldStyleBT-Roman',
};
